export const INVALID_EMAIL = "Invalid email";
export const INVALID_PASSPORT = "Invalid Passport Number";
export const INVALID_ID_NAME = "Invalid Name!";
export const INVALID_PHONE = "Invalid Phone Number";
export const REQUIRED_FIELD = "Required";
export const MAX_3_ITEM_VALIDATOR = "Max 3 Items Allowed";
export const INVALID_PINCODE = "Invalid Pincode";
export const MIN_LENGTH_MOBILE = "Mobile must be at least 10 digits";
export const MIN_LENGTH_INT_MOBILE = "Mobile must be at least 4 digits";
export const REQUIRED_FIELD_GREATERTHAN_0 = "Must Be Greater than 0";
export const MIN_LENGTH_PWD = "Password should be 6 chars minimum.";
export const SUCCESS = "Success";
export const INVALID = "Invalid";
